var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondsHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.4545mm",
    height: "149.42mm",
    viewBox: "0 0 7.4545455 149.42343",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93.035 -26.497)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -258.02 -41.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1326.8,
    y: 257.55,
    width: 28.175,
    height: 564.75,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.9)",
    fill: "#f00",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 958.06,
    y: 343.41,
    width: 3.8873,
    height: 219.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.41,
    y: 558.67,
    width: 11.176,
    height: 43.246
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 540,
    r: 7.7746
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondsHand);
export default __webpack_public_path__ + "static/media/seconds_hand.f158fd13e09493f24a1d119d7cceedc6.svg";
export { ForwardRef as ReactComponent };